import { createMuiTheme } from "@material-ui/core"
export const featuredList = [
  {
    id: 1,
    title: "Developed a React Native Ecommerce Templates",
    date: "Jun 2020",
    description:
      "This is a wider card with supporting text below as a natural lead-in to additional content.",
    image: "https://source.unsplash.com/random",
    imageText: "Image Text",
  },
  {
    id: 2,
    title: "Created a Dashboard for Majlis Perbandaran",
    date: "Jan 2020",
    description:
      "This is a wider card with supporting text below as a natural lead-in to additional content.",
    image: "https://source.unsplash.com/random",
    imageText: "Image Text",
  },
  {
    id: 3,
    title: "Published an Ecommerce sites selling in Malaysia",
    date: "Jun 2019",
    description:
      "This is a wider card with supporting text below as a natural lead-in to additional content.",
    image: "https://source.unsplash.com/random",
    imageText: "Image Text",
  },
  {
    id: 4,
    title: "Works on collaboration to build a startup",
    date: "May 2019",
    description:
      "This is a wider card with supporting text below as a natural lead-in to additional content.",
    image: "https://source.unsplash.com/random",
    imageText: "Image Text",
  },
]

export const themeColor = createMuiTheme({
  typography: {
    fontFamily: ["Quicksand", "sans-serif"].join(","),
  },
  palette: {
    primary: {
      main: "#ffeaa7",
    },
    secondary: {
      main: "#24292e",
    },
  },
})

export const FACEBOOK = "https://www.facebook.com/wanarif93"
export const TWITTER = "https://twitter.com/warifmust"
export const GITHUB = "https://github.com/warifmust"
export const LINKEDIN =
  "https://www.linkedin.com/in/wan-arif-wan-mustaffa-a62b0b120"
